import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const clientService = {
  get,
  getUsers,
  delClients,
  getClient,
  getOrganizationByClientCode,
  deleteOrganization
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'client'
};

function extract(r) {
  return r.data;
}

async function get() {
  return axios.get(model.baseUrl + 'client/get').then(extract);
}

async function getUsers(clientCode: string, edrpo: string) {
  var query = edrpo ? `client/getUsers?clientCode=${clientCode}&edrpo=${edrpo}` : `client/getUsers?clientCode=${clientCode}`;
  return axios.get(model.baseUrl + query).then(extract);
}

async function delClients(userCodes: string[], organizationCodes: string[]) {
  return axios.delete(model.baseUrl + 'client/deleteClient', { data: { userCodes, organizationCodes } }).then(extract);
}

function getClient(clientCode: string) {
  return axios.get(`${model.baseUrl}${model.controller}/getClient?clientCode=${clientCode}`).then(extract);
}

async function getOrganizationByClientCode(clientCode: string) {
  var query = `client/getOrganizationByClientCode?clientCode=${clientCode}`;
  return axios.get(model.baseUrl + query).then(extract);
}

async function deleteOrganization(clientCode: string) {
  return axios.delete(model.baseUrl + 'client/deleteorganization', { data: { clientCode } }).then(extract);
}
